import { Routes } from '@angular/router';
import { authGuard, guestGuard, permissionGuard } from './guards/auth.guard';
import { DefaultBodyComponent } from './layout/default-body/default-body.component';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'login',
    title: 'Sign in',
    canActivate: [guestGuard],
    loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: '',
    component: DefaultBodyComponent,
    canActivate: [authGuard],
    canActivateChild: [permissionGuard],
    loadChildren: () => import('./pages/pages.routes').then((m) => m.PAGES_ROUTES),
  },
  { path: '**', redirectTo: 'dashboard' },
];
